import { render, staticRenderFns } from "./ibItem.vue?vue&type=template&id=e28443b6&"
import script from "./ibItem.vue?vue&type=script&lang=js&"
export * from "./ibItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports